import { useFlags } from "launchdarkly-react-client-sdk";

/**
 * Chooses between the two trait API paths that currently coexist: Hasura's
 * generated `trait_definitions` endpoints (`false`) and the custom trait
 * resolvers plus the `traits_v2` remote relationship (`true`).
 *
 * The same flag also gates trait *permissions*: the "Manage traits" checkbox in
 * the parent-model grant editor, and whether the trait UI gates on the `trait`
 * v2 resource (`can_manage_trait`) or on the older `model`/`can_update` check.
 * Both switch on together deliberately. Whoever deletes this hook after the
 * rollout must retire `src/pages/traits/permission-utils.ts`'s flag-off arms and
 * `getResourceGrantOptions`' `traitGrantsEnabled` param along with it.
 *
 * Flags read as `undefined` until LaunchDarkly initializes, so `Boolean()`
 * makes the old path the default — the safe side while the new resolvers roll
 * out. Every dual-path call site reads the flag through this hook, so removing
 * it after the rollout is a single-file change.
 */
export function useNewTraitsEndpoints(): boolean {
  const { appUseNewTraitsEndpoints } = useFlags();
  return Boolean(appUseNewTraitsEndpoints);
}
